import { Form } from "@unform/web";
import { useEffect, useState } from "react";

import { HTTPErrorCallback } from "Helpers/Error";
import { formatCurrency } from "Helpers/Format";

import UseServices from "Hooks/UseServices";

import * as S from "./styles";

// Sessão VALOR APORTADO do projeto, na área do usuário.
//
// SOMENTE LEITURA para todo mundo desde 03/09/2026 (D5 da parte 2: "apenas
// admin cadastra os valores aportados"). O patrocinador já era (A12 — D4/D20);
// o PROPONENTE perdeu criar e editar, porque o aporte deixou de ser um "plano
// de cotas" que ele monta e passou a ser um fato que a Equipe Sevenx registra.
// A escrita vive só em /admin/projects/update/:id → aba "Valor Aportado".
//
// Sem o campo Nome (D6), cada aporte se identifica por PATROCINADOR + VALOR.
const Quotas = ({ projectId }) => {
  const { api } = UseServices();

  const [quotas, setQuotas] = useState([]);

  useEffect(() => {
    return getProjectQuotas(projectId);

    // eslint-disable-next-line
  }, []);

  const getProjectQuotas = (project_id) => {
    api
      .post("/project-quotas/get-project-quotas-by-project-id", {
        project_id: project_id,
      })
      .then((response) => setQuotas(response.data?.project_quotas || []))
      .catch((error) => {
        return HTTPErrorCallback(error);
      });
  };

  return (
    <S.Wrapper>
      <Form>
        <S.Section>
          <span>Valor Aportado</span>
          <hr />
        </S.Section>

        {!quotas.length ? <span>Nenhum valor aportado cadastrado.</span> : null}

        {quotas.map((quota) => (
          <S.Quota key={quota.id}>
            <S.QuotaInfos>
              <S.Header>
                {/* Patrocinador + valor no lugar do antigo `quota.name`. */}
                <h2>
                  {quota.project_sponsor
                    ? quota?.project_sponsor?.sponsor?.full_name
                    : "Não Cadastrado"}{" "}
                  — {formatCurrency(quota.value)}
                </h2>
              </S.Header>
            </S.QuotaInfos>
          </S.Quota>
        ))}
      </Form>
    </S.Wrapper>
  );
};

export default Quotas;
